import type {ReactNode} from "react";

import {cn} from "@/lib/utils";

type PublicPageShellProps = {
  children: ReactNode;
  className?: string;
};

/** Scrollable full-height shell for bare routes (auth, public claim) outside Layout. */
export function PublicPageShell({children, className}: PublicPageShellProps) {
  return (
    <div
      className={cn(
        "flex h-full min-h-0 flex-col overflow-x-hidden overflow-y-auto overscroll-y-contain bg-muted p-4 touch-pan-y [-webkit-overflow-scrolling:touch] pb-[max(1rem,var(--app-safe-area-bottom,env(safe-area-inset-bottom,0px)))]",
        className,
      )}
    >
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center py-8">
        {children}
      </div>
    </div>
  );
}
